import translation from 'locales/translation';
/* eslint-disable react-hooks/exhaustive-deps */
import { IconButton, Typography } from '@material-ui/core';
import { default as api } from 'api/Assessor/duvidas';
import { AxiosError } from 'axios';
import {
  CheckIcon,
  CircleTimes,
  CloseIcon,
  EditIcon,
  PlusIcon,
  SendIcon,
  SyncIcon,
} from 'components/Icons';
import LayoutContext from 'components/Layout/LayoutContext';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import { clsx, isNullOrUndefined } from 'helpers/utils/HTMLUtils';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import moment from 'moment';
import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';
import {
  Button,
  ButtonThemes,
  Modal,
  ModalManager,
  ModalSizes,
  ScreenSize,
  ToastTypes,
} from 'plataforma-fundacao-componentes';
import React, {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useMarcarLida } from 'services/chatAssessor';
import { assembleiasAssessorActionsResponderDuvida } from 'store/modules/AssembleiasAssessorActions';
import { IReducer } from 'store/Reducer';
import { toggleResponse } from '.';
import ChatContext from './ChatContext';
import FlagIsPuplic from './components/FlagIsPublic';
import ModalTimeoutChat from './components/modalTimeoutChat/ModalTimeoutChat';
import useStyle from './style';
import './styles.scss';

const rootClassName = 'responder';

export default function Responder() {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { atualizarMensagens, auth, conversaAtual, setDAtual } =
    useContext(MensagensContext);
  const { duvidaAtual, setDuvida, respostaPadraoResponse } =
    useContext(ChatContext);
  const [duvida2, setDuvida2] = useState<any>(duvidaAtual?.duvida);
  const [resposta, setResposta] = useState<any>('');
  const [toggle, setToggle] = useState<any>();
  const respostaRef = useRef(resposta);
  respostaRef.current = resposta;
  const [enviando, setEnviando] = useState<boolean>(false);
  const [respostaPadrao, setRespostaPadrao] = useState<any>();
  const params = useParams<{ idEvento?: string }>();

  const { usuario } = useSelector((state: IReducer) => state.auth);

  const { evento } = useSelector(
    (state: IReducer) => state.assembleiasAssessor
  );

  const responder = useMemo(() => {
    return (
      (usuario?.perfil.id === 'pertencer_consulta' &&
        !auth?.responder &&
        evento?.tipo === 'REU') ||
      auth?.responder
    );
  }, [auth?.responder, evento?.tipo, usuario?.perfil.id]);

  const [checked, setChecked] = useState<any>();
  const ChatModalManagerRef = useRef<any>();
  const openModal = <
    C extends React.ElementType,
    P extends React.ComponentProps<C>
  >(
    component: C,
    props: P
  ) => {
    ChatModalManagerRef?.current?.openModal(component, props);
  };
  const closeModal = (mk: any) => {
    ChatModalManagerRef?.current?.closeModal(mk!);
  };

  const { showToast } = useContext(LayoutContext);

  const { mutate } = useMarcarLida();

  const timerRef = useRef<any>();
  const dateMemo = useMemo(() => {
    if (duvidaAtual) {
      const date = moment();
      date.add(10, 'minutes');
      return date;
    }
    return undefined;
  }, [duvidaAtual]);

  useEffect(() => {
    if (dateMemo) {
      timerRef.current = setInterval(() => {
        if (moment().isAfter(dateMemo)) {
          const modalKey = `modal${getUniqueKey()}`;
          const message = respostaRef.current
            ? String(respostaRef.current)
            : '';
          openModal(ModalTimeoutChat, {
            message,
            modalKey,
            mobileOn: ScreenSize.xs,
            size: ModalSizes.Small,
            preventMaskExit: true,
            title: translation.TempoAcabouChatModal.title,
            children: translation.TempoAcabouChatModal.textWithMessage,
            messageWithout: translation.TempoAcabouChatModal.textWithoutMessage,
            onClose: () => {
              closeModal(modalKey);
              setTimeout(() => {
                setDuvida(undefined);
              }, 10);
            },
            footer: [
              {
                children: translation.TempoAcabouChatModal.confirmar,
                leftIcon: <CheckIcon />,
                onClick: () => {
                  closeModal(modalKey);
                  setTimeout(() => {
                    setDuvida(undefined);
                  }, 10);
                },
              },
            ],
          });
          clearInterval(timerRef!?.current);
        }
      }, 1000);

      return () => {
        if (timerRef && timerRef.current) clearInterval(timerRef!?.current);
      };
    }
  }, [dateMemo]);

  useEffect(() => {
    if (typeof setDAtual === 'function') {
      setDAtual(duvidaAtual);
    }
    return () => {
      if (typeof setDAtual === 'function') {
        setDAtual(undefined);
      }
    };
  }, [duvidaAtual]);

  useLayoutEffect(() => {
    setDuvida2(duvidaAtual?.duvida);
    setToggle(
      duvidaAtual?.resposta
        ? duvidaAtual?.flgPublica
        : respostaPadraoResponse?.publico
    );
  }, [duvidaAtual]);

  useLayoutEffect(() => {
    if (!checked && respostaPadrao) {
      setResposta(respostaPadrao);
    }
  }, [checked, respostaPadrao]);

  useLayoutEffect(() => {
    setResposta(
      conversaAtual && conversaAtual.nome === 'Administrador da Assembleia'
        ? duvidaAtual?.duvida
        : duvidaAtual?.resposta
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duvidaAtual]);

  const handleChangeCheck = (resp: any) => {
    setRespostaPadrao(resp);
  };

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setEnviando(true);
      dispatch(
        assembleiasAssessorActionsResponderDuvida(
          duvidaAtual!.idDuvidaFrequente,
          resposta,
          toggle,
          () => {
            toast.success(translation.AssessorMensagens['success-answer']);
            setDuvida(undefined);
            setEnviando(false);
            setTimeout(() => {
              setRespostaPadrao(undefined);
              setChecked(undefined);
              if (
                conversaAtual?.duvidas.every(
                  (x) => !isNullOrUndefined(x.resposta)
                )
              ) {
                return mutate(
                  {
                    idEvento: String(params.idEvento),
                    cpf: conversaAtual?.cpfUsuario,
                  },
                  {
                    onSuccess: () => {},
                    onError: (error) => {
                      showToast({
                        pauseOnFocusLoss: true,
                        theme: ToastTypes.Error,
                        showStatusBar: true,
                        timeout: 4000,
                        label:
                          translation.Toasts.Errors.Keys[
                            `${
                              (error as AxiosError<Error>).response?.data
                                .message ||
                              (error as AxiosError<Error>).response?.data ||
                              (error as AxiosError<Error>).message
                            }` as keyof typeof translation.Toasts.Errors.Keys
                          ] ?? translation.Toasts.Errors.defaultAlternative,
                      });
                    },
                  }
                );
              }
            }, 100);
          },
          (fail) => {
            ErrorHandler(fail);
            setEnviando(false);
          }
        )
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, duvidaAtual, resposta, toggle, setDuvida, atualizarMensagens]
  );

  const handleEditMessage = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      const { fail, data } = await api.editarMensagem({
        idDuvida: duvidaAtual!.idDuvidaFrequente,
        duvida: resposta,
        flgPublica: toggle,
      });
      if (fail) {
        ErrorHandler(fail);
      }
      if (data) {
        toggleResponse({
          idDuvida: duvidaAtual!?.idDuvidaFrequente,
          flgEmEdicao: Boolean(duvidaAtual!?.resposta),
          flgEmResposta: false,
        });
        setTimeout(() => {
          atualizarMensagens();
        }, 10);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [atualizarMensagens, duvidaAtual, resposta, toggle]
  );

  if (!responder || !duvidaAtual) return null;

  const handleKeyDown = (e: any) => {
    e.target.style.height = 'inherit';
    let limit = 100;
    const computed = window.getComputedStyle(e.target);
    const height =
      parseInt(computed.getPropertyValue('border-top-width'), 10) +
      parseInt(computed.getPropertyValue('padding-top'), 10) +
      e.target.scrollHeight +
      parseInt(computed.getPropertyValue('padding-bottom'), 10) +
      parseInt(computed.getPropertyValue('border-bottom-width'), 10);
    e.target.style.height = `${Math.min(height, limit)}px`;
  };

  return (
    <React.Fragment>
      <ModalManager ref={ChatModalManagerRef} />
      <form
        className={clsx([
          `${rootClassName}`,
          'animation-slide-up',
          resposta?.length > 500 ? 'error' : '',
        ])}
        onSubmit={(e) => e.preventDefault()}
      >
        <div className={classes.inputDuvida}>
          <Typography className={classes.inputDuvidaText}>
            {duvidaAtual.duvida}
          </Typography>
          <IconButton
            className={classes.cancelarResposta}
            onClick={() => {
              setDuvida(undefined);
              toggleResponse({
                idDuvida: duvidaAtual?.idDuvidaFrequente,
                flgEmEdicao: false,
                flgEmResposta: false,
              });
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div className={`${rootClassName}-container`}>
          <div className={`${rootClassName}-send`}>
            <textarea
              placeholder={translation.AssessorMensagens.write}
              className={clsx([
                `${rootClassName}-textarea`,
                resposta?.length > 500 ? 'error' : '',
              ])}
              onChange={(evt: any) => {
                setResposta(evt.target.value);
              }}
              value={resposta || ''}
              autoFocus
              disabled={enviando}
              onKeyDown={(e) => handleKeyDown(e)}
            />

            <div className={classes.endAdornment}>
              <Typography className={classes.counter}>
                <span className={resposta?.length > 500 ? 'error' : ''}>
                  {!resposta?.length
                    ? `0`
                    : resposta?.length ||
                      duvidaAtual?.resposta?.length ||
                      duvida2.length}
                </span>
                /500
              </Typography>
              <IconButton
                type='submit'
                className={classes.submitIcon}
                color='primary'
                disabled={
                  enviando || !resposta?.length || resposta?.length > 500
                }
                onClick={(e: any) => {
                  if (conversaAtual!.nome === 'Administrador da Assembleia') {
                    handleEditMessage(e);
                  } else {
                    handleSubmit(e);
                  }
                }}
              >
                {conversaAtual!.nome === 'Administrador da Assembleia' ? (
                  <EditIcon style={{ width: '18px', height: '18px' }} />
                ) : enviando ? (
                  <SyncIcon animated />
                ) : (
                  <SendIcon />
                )}
              </IconButton>
            </div>
          </div>
          <hr className={`${rootClassName}-divider`} />
          <div className={`${rootClassName}-footer-btns`}>
            <Button
              leftIcon={<PlusIcon />}
              onClick={() => {
                const mKey = `alert${getUniqueKey()}`;
                openModal(Modal, {
                  preventMaskExit: true,
                  size: ModalSizes.Small,
                  modalKey: mKey,
                  title: translation.ChatModal.respostasPadrao.title,
                  onClose: () => {
                    closeModal(mKey);
                    setChecked(undefined);
                    setRespostaPadrao(undefined);
                  },
                  children: (
                    <>
                      {!respostaPadraoResponse?.respostasPadroes.length ? (
                        <>
                          <p
                            className={`${rootClassName}-respostaModal-message`}
                          >
                            {translation.ChatModal.respostasPadrao.semResposta}
                          </p>
                          <p
                            className={`${rootClassName}-respostaModal-message`}
                          >
                            {translation.ChatModal.respostasPadrao.obs}
                          </p>
                        </>
                      ) : (
                        <>
                          <p
                            className={`${rootClassName}-respostaModal-title-top`}
                          >
                            {translation.ChatModal.respostasPadrao.selecao}
                          </p>
                          {respostaPadraoResponse?.respostasPadroes.map(
                            (dados: any) => {
                              return (
                                <div
                                  key={dados.id}
                                  className={`${rootClassName}-container-radio`}
                                >
                                  <input
                                    className={`${rootClassName}-radio`}
                                    type={'radio'}
                                    name={'options'}
                                    value={dados.mensagem || ''}
                                    id={dados.id}
                                    onChange={(e) => {
                                      handleChangeCheck(
                                        resposta
                                          ? resposta + ` ${e.target.value}`
                                          : e.target.value
                                      );
                                      setChecked(e.target.value);
                                    }}
                                  />
                                  <label htmlFor={dados.id}>
                                    <p
                                      className={`${rootClassName}-respostaModal-title`}
                                    >
                                      {dados.assunto}
                                    </p>
                                    <p
                                      className={`${rootClassName}-respostaModal-message`}
                                    >
                                      {dados.mensagem}
                                    </p>
                                  </label>
                                </div>
                              );
                            }
                          )}
                        </>
                      )}
                    </>
                  ),
                  footer: respostaPadraoResponse?.respostasPadroes.length && [
                    {
                      theme: ButtonThemes.Secondary,
                      leftIcon: <CircleTimes />,
                      onClick: () => {
                        closeModal(mKey);
                        setChecked(undefined);
                        setRespostaPadrao(undefined);
                      },
                      children: 'Cancelar',
                    },
                    {
                      theme: ButtonThemes.Primary,
                      leftIcon: <PlusIcon />,
                      onClick: () => {
                        closeModal(mKey);
                        setChecked(undefined);
                        if (!resposta) {
                          setResposta(respostaPadrao);
                          setTimeout(() => {
                            setRespostaPadrao(undefined);
                          }, 100);
                        }
                      },

                      children: 'Adicionar',
                    },
                  ],
                });
              }}
            >
              {translation.ChatModal.respostasPadrao.adicionar}
            </Button>
            <FlagIsPuplic
              setPublic={() => setToggle(true)}
              setPrivate={() => setToggle(false)}
              disabledPublic={toggle}
              disabledPrivate={!toggle}
            />
          </div>
        </div>
      </form>
    </React.Fragment>
  );
}
